<template>
  <div class="main">
    <!--<div class="cate-lists help">-->
    <!--<span>双击专题名称可快速编辑<br>拖动专题名称后的"<a-icon type="drag"/>"可对专题排序</span>-->
    <!--</div>-->
    <div class="cate-lists help">
      <a-popconfirm placement="bottomRight">
        <template slot="title">
          <p>双击专题名称可快速编辑</p>
          <p>拖动专题名称后的"<a-icon type="drag" />"可对专题排序</p>
        </template>
        <a-icon type="question-circle" />
      </a-popconfirm>
    </div>

    <a-card :bordered="false" class="cate-lists">
      <div class="title">
        <span class="info">专题列表</span>
        <span class="operator" @click="add">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>新增专题</span>
            </template>
            <a-icon type="plus" /> 添加
          </a-tooltip>
        </span>
      </div>
      <p v-if="lists.length == 0">暂无内容</p>
      <SlickList
        :lockToContainerEdges="true"
        lockAxis="y"
        v-model="lists"
        @input="getChangeLists"
        :useDragHandle="true"
      >
        <!--<div v-for="(item, index) in lists" :key="index"  class="lists move">-->
        <SlickItem
          :index="index"
          v-for="(item, index) in lists"
          :key="index"
          class="lists move"
        >
          <span
            class="catname"
            v-if="quickEditId != index"
            @dblclick="edit(index)"
          >
            {{ item.catname }}
            <span class="info">专题ID:{{ item.catid }}</span>
          </span>
          <span class="catname" v-else>
            <a-input-group style="margin-top:10px;line-height: 30px">
              <a-col :span="16">
                <a-input
                  v-model="catname"
                  @keyup.enter="saveEdit"
                  @keyup.esc="cancelEdit"
                />
              </a-col>
              <a-col :span="8">
                <a-button size="small" @click="cancelEdit">取消</a-button>
                <a-button type="primary" size="small" @click="saveEdit"
                  >保存</a-button
                >
              </a-col>
            </a-input-group>
          </span>

          <span class="operator">
            <a slot="actions" @click="setSource(item, index)">数据来源</a>
            <a slot="actions" @click="editCate(item, index)">编辑</a>
            <a slot="actions" @click="delCate(item, index)">删除</a>
            <a-icon type="drag" v-handle />
          </span>
        </SlickItem>
        <!--</div>-->
      </SlickList>
    </a-card>

    <a-modal
      title="添加专题"
      v-model="catemodal"
      @cancel="cancelModal"
      @ok="addCate"
      class="cate-type"
    >
      <p>
        <a-input
          placeholder="请输入专题名称"
          v-model="catname"
          @keyup.enter="addCate"
          style="width: 70%;margin-right: 10px"
        />
        <a-button type="primary" v-if="link" @click="link = false">
          外部链接<a-icon type="check" />
        </a-button>
        <a-button type="dashed" v-else @click="link = true">外部链接</a-button>
      </p>
      <p v-if="link">
        <a-input
          placeholder="链接地址"
          v-model="linkurl"
          @keyup.enter="addCate"
        />
      </p>

      <p>
        展示渠道：
        <span v-for="(item, i) in cType" :key="i">
          <a-button
            @click="setcType(item.value)"
            :key="item.value"
            v-if="selectcType.indexOf(item.value) > -1"
            type="primary"
          >
            <a-icon :type="item.icon" />{{ item.label }}
          </a-button>
          <a-button @click="setcType(item.value)" :key="item.value" v-else>
            <a-icon :type="item.icon" />{{ item.label }}
          </a-button>
        </span>
      </p>
      <div>
        <div style="height: 32px">专题头图：</div>
        <a-upload-dragger
          name="file"
          :multiple="true"
          action="https://api.ycrmt.cn/api/AliyunOss/Imgesupload"
          :data="imgdata"
          :headers="headers"
          @change="handleChange"
          :beforeUpload="beforeUpload"
          v-if="photo == ''"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-hint">点击上传专题封面图片</p>
        </a-upload-dragger>
        <div v-else class="cover-img" @click="clearImg()">
          <img :src="photo" style="height: 100%;width: 100%" />
        </div>
      </div>
      <p>
        <a-checkbox @change="onSetTemp" :checked="templateSet"
          >设置模板</a-checkbox
        >
      </p>
      <p v-show="templateSet">
        <a-input
          addonBefore="栏目页模板"
          placeholder="请输入模板名称"
          v-model="template.index"
        />
      </p>
      <p v-show="templateSet">
        <a-input
          addonBefore="列表页模板"
          placeholder="请输入模板名称"
          v-model="template.list"
        />
      </p>
      <p v-show="templateSet">
        <a-input
          addonBefore="内容页模板"
          placeholder="请输入模板名称"
          v-model="template.show"
        />
      </p>
      <!--selectcType.indexOf(String(parseInt(index) + 1))-->
      <!--<a-switch checkedChildren="外链" unCheckedChildren="内部" defaultChecked/>-->
    </a-modal>
    <a-modal
      title="设置数据来源"
      v-model="sourcemodal"
      @cancel="cancelSourceModal"
      @ok="addSource"
      width="700px"
    >
      <div>
        <a-transfer
          :dataSource="mockData"
          :titles="['可用栏目', '已绑定栏目']"
          :targetKeys="targetKeys"
          :selectedKeys="selectedKeys"
          showSearch
          :filterOption="filterOption"
          @change="handleSource"
          @selectChange="handleSelectChange"
          @scroll="handleScroll"
          :render="item => item.title"
          :disabled="disabled"
          :listStyle="{
            width: '300px',
            height: '300px'
          }"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { SlickList, SlickItem, HandleDirective } from 'vue-slicksort';
export default {
  directives: { handle: HandleDirective },
  components: {
    SlickItem,
    SlickList
  },
  data() {
    return {
      setCateid: 0,
      sourcemodal: false,
      mockData: [],
      targetKeys: [],
      selectedKeys: [],
      disabled: false,
      // templateStatus: false,
      templateSet: false,
      photo: '',
      link: false,
      linkurl: '',
      catname: '',
      catemodal: false,
      flag: true,
      lists: [],
      editId: -1,
      quickEditId: -1,
      cType: [
        { icon: 'desktop', label: 'PC', value: '1' },
        { icon: 'mobile', label: 'App', value: '2' },
        { icon: 'html5', label: 'H5', value: '3' }
      ],
      selectcType: '1,2,3',
      template: { index: '', list: '', show: '' },
      headers: {
        Authorization: window.localStorage.getItem('token')
      },
      imgdata: {
        blob_num: 1,
        total_blob_num: 1,
        file_name: '123.jpg'
      },
      busy: false
    };
  },
  created() {
    this.getCateList();
    // this.loadChildCate()
  },
  methods: {
    handleSource(nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys;
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
    handleScroll(direction, e) {
      // console.log('direction:', direction);
      // console.log('target:', e.target);
    },
    addSource() {
      // console.log(this.setCateid,'addSource')
      // console.log(this.targetKeys)
      let param = {
        targetCid: parseInt(this.setCateid),
        selectedCid: this.targetKeys.join(',')
      };
      this.$http.post('/api/content/categoryupdatepid', param).then(res => {
        if (res.data.state == 200) {
          this.$message.success('数据绑定成功！');
          this.sourcemodal = false;
        }
        // console.log(JSON.stringify(res.data))
      });
    },
    cancelSourceModal() {
      this.setCateid = 0;
      this.sourcemodal = false;
    },
    setSource(item) {
      this.sourcemodal = true;
      // this.selectedKeys = []
      this.mockData = [];
      this.setCateid = item.catid;
      this.loadChildCate(item);
    },
    loadChildCate(item) {
      // 载入所有未设置父栏目的栏目，用于设置专题数据来源
      this.$http
        .post('/api/content/categorylist', { limit: 9999, catclass: 1 })
        .then(res => {
          // console.log(JSON.stringify(res.data.data))
          for (let i in res.data.data) {
            if (res.data.data[i].parentid) {
              this.mockData.push({
                key: res.data.data[i].catid,
                title: res.data.data[i].catname,
                description: res.data.data[i].catname
              });
              if (item.catid == res.data.data[i].parentid) {
                this.targetKeys.push(res.data.data[i].catid);
              }
            }
          }
        });
    },
    onSetTemp(e) {
      this.templateSet = e.target.checked;
    },
    clearImg() {
      let that = this;
      this.$confirm({
        title: '删除封面图',
        content: '确认删除当前专题的封面图吗？',
        onOk() {
          that.photo = '';
        },
        onCancel() {}
      });
    },
    beforeUpload(file) {
      this.imgdata.file_name = file.name;
      // console.log(this.imgdata.file_name)
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        this.$message.success('文件上传成功');
        this.busy = false;
        this.photo = info.file.response.url;
      } else if (info.file.status === 'error') {
        this.$message.success('文件上传失败');
        // this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    setcType(value) {
      let cTypeArr = this.selectcType.split('');
      if (cTypeArr.indexOf(value) > -1) {
        cTypeArr.splice(cTypeArr.indexOf(value), 1);
      } else {
        cTypeArr.push(value);
      }
      cTypeArr.sort();
      this.selectcType = cTypeArr.join('');
      console.log(this.selectcType);
    },
    delCate(item, index) {
      let that = this;
      this.$confirm({
        title: '删除专题',
        content: '删除专题后将无法恢复，确定操作吗？',
        onOk() {
          that.$http
            .post('/api/content/categorydel', { ids: item.catid })
            .then(res => {
              if (res.data.state == 200) {
                that.$message.success('操作成功');
                that.lists = [];
                that.getCateList();
              } else {
                that.$message.error('操作失败，请刷新页面重试');
              }
            });
        },
        onCancel() {}
      });
    },

    editCate(item, index) {
      this.templateSet = false;
      this.template = { index: '', list: '', show: '' };
      if (item.template !== null && item.template != '') {
        this.template = JSON.parse(item.template);
      }
      this.editId = index;
      this.catname = item.catname;
      this.photo = item.photo;
      if (item.linkurl != null && item.linkurl != '') {
        this.link = true;
        this.linkurl = item.linkurl;
      } else {
        this.link = false;
        this.linkurl = '';
      }
      this.selectcType = item.ctype;
      this.catemodal = true;
    },
    cancelEdit() {
      this.catname = '';
      this.selectcType = '1';
      this.editId = -1;
      this.quickEditId = -1;
    },
    saveEdit() {
      this.addCate();
    },
    edit(index) {
      this.catname = this.lists[index].catname;
      this.editId = index;
      this.quickEditId = index;
    },
    getCateList() {
      this.$http
        .post('/api/content/categorylist', { catclass: 2, limit: 9999 })
        .then(res => {
          this.lists = res.data.data;
        });
    },
    cancelModal() {
      this.catemodal = false;
      this.catname = '';
    },
    add() {
      this.editId = -1;
      this.quickEditId = -1;
      this.catname = '';
      this.link = false;
      this.catemodal = true;
    },
    addCate() {
      if (this.catname != '') {
        let lists = this.lists;
        // 编辑时将被编辑元素自身剔除名称重复检测
        let param = new Object();
        if (this.editId >= 0) {
          param = { id: this.lists[this.editId].catid, catname: this.catname };
        } else {
          param = { catname: this.catname };
        }
        if (this.link) {
          param.linkurl = this.linkurl;
        }
        if (this.editId >= 0) {
          lists.splice(this.editId, 1);
        }
        let exist = 0;
        for (let i in lists) {
          if (lists[i].catname == this.catname) {
            exist++;
          }
        }
        param.ctype = this.selectcType;
        param.catclass = 2;
        param.photo = this.photo;
        param.template = JSON.stringify(this.template);
        if (exist == 0) {
          // this.$message.success('ok')
          this.$http.post('/api/content/categoryupdate', param).then(res => {
            if (res.data.state == 200) {
              if (this.editId >= 0) {
                this.$message.success('保存成功');
              } else {
                this.$message.success('添加成功');
              }

              this.lists = [];
              this.getCateList();
            } else {
              this.$message.error(
                '专题添加失败，错误原因：' + res.data.message
              );
            }
          });
          this.editId = -1;
          this.catname = '';
          this.catemodal = false;
        } else {
          this.$message.warn('专题名称重复');
        }
      }
    },
    getChangeLists(vals) {
      let cataArr = [];
      for (let i in vals) {
        cataArr.push(vals[i].catid);
      }
      this.$http
        .post('/api/content/categorylistorder', { ids: cataArr.join(',') })
        .then(res => {
          console.log(res.data);
        });
    },
    filterOption(inputValue, option) {
      return option.description.indexOf(inputValue) > -1;
    }
  }
};
</script>
<style type="text/scss" scoped>
.main {
  position: absolute;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
}
.cate-lists {
  width: 710px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.catname .info {
  padding-left: 20px;
  display: none;
}

.catname:hover .info {
  color: #9ca9b3;
  display: inline-block;
}
.catname .info > i {
  margin-right: 5px;
}
.ant-btn {
  margin-right: 10px;
}
.help {
  color: #9ea1b4;
  text-align: right;
  height: 30px;
  line-height: 28px;
}
.help i {
  cursor: pointer;
}

.cate-lists .title {
  height: 55px;
  line-height: 55px;
}
.cate-lists .title .info {
  font-size: 16px;
  font-weight: bold;
}
.cate-lists .title .operator {
  cursor: pointer;
  position: absolute;
  right: 20px;
}

.lists {
  height: 50px;
  line-height: 50px;
  border-top: 2px solid #eee;
}
.lists > div {
  display: inline;
  width: 200px;
  position: absolute;
  right: 0;
}
.operator {
  position: absolute;
  right: 20px;
}
/*.listss>div>span.operator a {*/
/*margin-right: 10px;*/
/*}*/
.operator a {
  margin-right: 10px;
}
.catname {
  display: inline-block;
  width: 400px;
  cursor: pointer;
}
.catname:hover {
  color: #1890ff;
}
.cover-img {
  cursor: pointer;
  border: 1px dashed #d9d9d9;
  border-radius: 3px;
  padding: 3px;
  height: 120px;
  width: 480px;
}
</style>
